import React, { useEffect, useState } from "react";
import "./Home.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import EmailIcon from "@mui/icons-material/Email";

export default function Home() {
  const [experience, setExperience] = useState([]);
  const data = [
    {
      company: "MMIT",
      position: "Senior Software Engineer",
      description: "",
      list: [
        "Designed, built, and maintained customer-facing SaaS applications delivering market access and analytics data, including Interactive Visual Aids (IVAs) running within the Veeva CRM platform (Salesforce and VaultCRM) and communicating with backend services via web APIs.",
        "Led and contributed to full-stack feature development across multiple products, spanning React front-end components, back-end services, and CI/CD integration, with a focus on reliability, maintainability, and production readiness.",
        "Designed and deployed scalable, cloud-native services on Microsoft Azure, integrating Web Apps, Function Apps, Blob Storage, Redis Cache, Key Vault, and App Configuration to support multi-tenant workflows.",
        "Served as a core front-end contributor on MMIT’s centralized platform, shaping UI architecture and building React interfaces with Material-UI (MUI), including complex tables, forms, and Highcharts visualizations.",
        "Designed and owned a shared component library extending MUI DataGrid Pro, improving UI consistency, reuse, and development velocity across embedded and standalone applications.",
        "Acted as a technical partner in evolving platform capabilities, improving user workflows, data accessibility, and interface consistency across MMIT’s SaaS offerings.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Music Choice",
      position: "Staff Software Engineer - Cloud Services",
      description: "",
      list: [
        "Modernized legacy systems by upgrading from .NET Framework/Standard 2.0 to .NET 6, building REST APIs with strong logging, metrics, and alerting (Application Insights, Microsoft Teams).",
        "Built and maintained CI/CD pipelines in Azure DevOps, automating builds, tests, NuGet packages, Docker images, and gated deployments.",
        "Integrated MSAL authentication with Office 365 and implemented role-based access for SPAs and ASP.NET APIs.",
        "Authored system documentation, architecture diagrams, and cost analyses.",
        "Worked closely with Principal Architects on long-term platform strategy.",
        "Mentored engineers in design patterns, performance optimization, and advanced C# techniques.",
        "Experience with Azure Functions, Event Hub/Grid, Service Bus, Cosmos DB, and Power Automate.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Music Choice",
      position: "Staff Software Engineer",
      description: "",
      list: [
        "Contributed to long-term architecture planning and platform modernization initiatives.",
        "Introduced Proxmox to host Linux Containers (LXCs), significantly reducing licensing costs.",
        "Implemented real-time monitoring with Prometheus and Grafana, improving early incident detection and system reliability.",
        "Identified and resolved storage performance bottlenecks, improving overall system responsiveness.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Music Choice",
      position: "Senior Application Developer",
      description: "",
      list: [
        "Built an internal engineering dashboard integrating REST APIs, WCF services, databases, and caching, saving hours of daily support effort.",
        "Led migration of source control from SVN to Azure Repos, defining branching strategy and CI/CD standards.",
        "Implemented RabbitMQ high-availability clusters and built message-driven microservices using .NET Core and Node.js.",
        "Designed and deployed high-performance Node + Puppeteer rendering services generating hundreds of thousands of images per day.",
        "Developed multi-threaded TCP/UDP socket processors in .NET Core and .NET 5.",
        "Replaced legacy ASP Classic systems with modern .NET Core + Angular applications.",
        "Improved performance using Redis and MongoDB and administered Linux servers in high-availability environments.",
        "Automated deployments and infrastructure using PowerShell, build agents, and Linux automation.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Experian Healthcare",
      position: "Software Developer III",
      description: "",
      list: [
        "Owned and delivered high-priority projects with minimal supervision.",
        "Built new platform features and optimized business logic to improve performance and maintainability.",
        "Migrated standalone tools into a centralized web platform, reducing turnaround time from hours to minutes.",
        "Integrated WACOM device functionality for signature capture within enterprise web applications.",
        "Conducted security reviews and remediated vulnerabilities identified by Veracode.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Experian Healthcare",
      position: "Software Developer II",
      description: "",
      list: [
        "Improved performance and stability of enterprise applications through enhanced logging and troubleshooting.",
        "Conducted impact analyses for new features and business logic updates.",
        "Redesigned a large-scale image processing system using OOP and design patterns, leveraging iTextSharp and GhostScript.",
        "Developed SSIS-based ETL pipelines and custom parsers for automated data processing.",
        "Mentored offshore developers and onboarded new engineers; authored technical documentation and diagrams.",
        "Automated repetitive workflows using event-driven architectures.",
        "Worked directly with clients on-site to resolve escalations.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Experian Healthcare",
      position: "Software Developer I",
      description: "",
      list: [
        "Built automation tools using iMacros with SQL-backed data pipelines.",
        "Parsed and extracted structured data using HTML Agility Pack, XPath, and Regex in C#.",
        "Created and maintained SQL stored procedures for application logic and reporting.",
        "Built scheduled services and console applications to generate client-specific data outputs.",
        "Developed internal WinForms tools to streamline onboarding and reduce support turnaround time.",
      ],
      start: "",
      end: "",
    },
    {
      company: "Buzzbox Media",
      position: "Junior Web Developer",
      description: "",
      list: [
        "Maintained and updated client-facing web pages and browser extensions (Chrome and Firefox).",
        "Built a PHP-based web scraper to automate performance metrics collection.",
        "Used Google Analytics to track user behavior and generate daily reports for internal teams.",
      ],
      start: "",
      end: "",
    },
  ];

  useEffect(() => {
    let grps = Object.groupBy(data, ({ company }) => company);

    setExperience(grps);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = (evt) => {
    let sections = document.querySelectorAll("section");

    let tempCurrentSection = "";
    for (let section of sections) {
      if (window.scrollY > section.offsetTop) {
        tempCurrentSection = section.id;
      }
    }
  };

  return (
    <div className="Home">
      <header className="Home-header michroma-regular">
        <Box>
          <Grid container spacing={2}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 4 }}
              height={"100vh"}
              alignContent={"center"}
            >
              <div style={{ fontSize: "50px" }}>Denny</div>
              <div style={{ fontSize: "50px" }}>Daniel</div>
              {/* <div style={{ fontSize: "50px" }}>Coding</div> */}
              <div style={{ fontSize: "15px", margin: "25px 0px" }}>
                Full Stack Software Engineer
              </div>
              <div>
                <a className="Home-nav" href="#about">
                  ABOUT
                </a>
              </div>
              <div>
                <a className="Home-nav" href="#experience">
                  EXPERIENCE
                </a>
              </div>

              <div style={{ marginTop: "10px" }}>
                <a
                  href="mailto:contact@dennyscoding.com"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    margin: "0 10px",
                  }}
                >
                  <EmailIcon />
                </a>

                <a
                  href="https://www.linkedin.com/in/dennygdaniel"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    margin: "0 10px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-6 w-6"
                    aria-hidden="true"
                    height="24px"
                    width="24px"
                  >
                    <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                  </svg>
                </a>
              </div>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 8 }}
              style={{
                textAlign: "justify",
                fontFamily: "Space Mono",
                fontSize: "16px",
                paddingBottom: "100px",
                paddingRight: "1rem",
              }}
              className="Home-right"
            >
              <section
                id="about"
                style={{ height: "100vh", alignContent: "center" }}
              >
                <p>
                  I'm a full-stack software engineer with experience designing
                  and delivering scalable web applications. I enjoy solving
                  complex technical challenges, mentoring teams, and shaping
                  architecture that drives business outcomes. I thrive in
                  collaborative, innovative environments and am always learning
                  new ways to improve systems and workflows.
                </p>
              </section>

              <section id="experience" style={{ top: "100vh" }}>
                {Object.keys(experience).map((key) => {
                  return (
                    <CompanyExperience
                      company={key}
                      experiences={experience[key]}
                    />
                  );
                })}
              </section>
            </Grid>
          </Grid>
        </Box>
      </header>
    </div>
  );
}

function CompanyExperience({ company, experiences }) {
  return (
    <>
      <p style={{ fontFamily: "Space Mono" }}>{company}</p>
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        {experiences.map((exp) => {
          return (
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography
                  variant="h6"
                  component="span"
                  sx={{ fontFamily: "Space Mono" }}
                >
                  {exp.position}
                </Typography>
                {exp.description && (
                  <Typography sx={{ fontFamily: "Space Mono" }}>
                    {exp.description}
                  </Typography>
                )}
                {!exp.description && exp.list && exp.list.length > 0 && (
                  <ExperienceList list={exp.list} />
                )}
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
      <Divider sx={{ borderColor: "white", opacity: 0.2 }} />
    </>
  );
}

function ExperienceList({ list }) {
  if (Array.isArray(list))
    return (
      <ul>
        {list.map((l) => (
          <li style={{ fontFamily: "Space Mono" }}>
            <ExperienceList list={l} />
          </li>
        ))}
      </ul>
    );

  if (typeof list === "object" && list != null) {
    let items = [];
    for (const key in list) {
      items.push(
        <>
          {key}
          <ul>
            {list[key].map((v) => (
              <li style={{ fontFamily: "Space Mono" }}>{v}</li>
            ))}
          </ul>
        </>
      );
    }

    // primitive type
    return items.map((i) => i);
  }

  return list;
}
